<template>
  <div class="view--gifts">
    <loader v-if="loader"></loader>

    <header class="header" v-if="!inApp">
      <div class="containter">
        <div class="row justify-content-center">
          <div class="col col-md-6 col-lg-4">
            <nav class="nav">
              <router-link :to="{ name: 'Index' }" tag="div" class="back"><i class="material-icons icon">chevron_left</i></router-link>
              <h1 class="title">{{ $t('gifts.giftInbox') }}</h1>
              <div class="placeholder"></div>
            </nav>
          </div>
        </div>
      </div>
    </header>

    <main :class="{ 'in-app': inApp }" v-cloak>
      <section class="section section--gifts">
        <div class="containter">
          <div class="row no-gutters justify-content-center">
            <div class="col col-md-6 col-lg-4">
              <div class="gifts pt-1">
                <base-tabs v-model="activeTab" :tabs="tabs">
                  <template slot-scope="{ tabs }">
                    <base-tab
                      v-for="tab in tabs"
                      :key="tab.name"
                      :name="tab.name"
                      :label="tab.label"
                    >
                      <!-- 未參與、已參與 -->
                      <template v-if="gifts.length > 0">
                        <GiftsItem
                          v-for="item in gifts"
                          :key="item.id"
                          :title="item.title"
                          :timestamp="tab.name === 'used' ? item.usedTime : item.startTime"
                          :type="item.type"
                          :typeName="typeName(item.type)"
                          :url="item.url"
                          :unread="!item.checked"
                          :used="item.used"
                        />
                      </template>
                      <BaseEmpty v-else />
                    </base-tab>
                  </template>
                </base-tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import Axios from '@/helpers/axios';
import Loader from '@/components/Loader.vue';
import BaseTabs from '@/components/BaseTabs.vue';
import BaseTab from '@/components/BaseTab.vue';
import BaseEmpty from '@/components/BaseEmpty.vue';
import GiftsItem from '@/components/GiftsItem.vue';

/**
 * 活動類別對應表
 */
const typesMap = {
  LUCKY_DRAW: 'gifts.luckyDraw', // 行動刮刮卡
  LUCKY_PICK: 'gifts.luckyPick', // 四選一
  LUCKY_SWAPPER: 'gifts.luckySwapper', // 快選
  LUCKY_SPIN: 'gifts.luckySpin', // 轉盤
  QA: 'gifts.questionnaire', // 行動智慧問卷
};

export default {
  name: 'Gifts',
  components: {
    Loader,
    BaseTabs,
    BaseTab,
    BaseEmpty,
    GiftsItem,
  },
  computed: {
    ...mapState({
      loader: 'loader',
      phoneType: state => state.client.phoneType,
    }),
    ...mapGetters([
      'inApp',
    ]),
    /**
     * 活動類型名稱
     * @returns {string}
     */
    typeName() {
      return type => this.$t(typesMap[type]);
    },
  },
  data() {
    return {
      // 當前造訪的頁籤
      activeTab: 'unused',
      // 禮物盒清單
      gifts: [],
      // 頁籤列表
      tabs: [
        {
          name: 'unused',
          label: this.$t('gifts.unused'),
        },
        {
          name: 'used',
          label: this.$t('gifts.used'),
        },
      ],
    };
  },
  methods: {
    ...mapMutations(['setLoader']),
    /**
     * 取得禮物盒清單
     * @param {String} name - 頁籤名稱
     */
    getGifts(name = '') {
      this.setLoader(true);
      this.gifts = [];

      Axios({
        method: 'POST',
        url: 'v2/ocard/getGiftBox',
        withCredentials: false,
        data: {
          brand_id: this.$route.params.brand,
          used: name === 'used' ? 1 : 0,
          platform: this.phoneType,
        },
      }).then((response) => {
        const { data: lists } = response.data;
        this.gifts = lists;
      }).finally(() => this.setLoader(false));
    },
  },
  watch: {
    activeTab: {
      handler(name) {
        this.getGifts(name);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="sass" scoped>
.view--gifts
  position: relative
  width: 100%
  height: 100%

  .header
    position: fixed
    top: 0
    right: 0
    left: 0
    padding: 12px
    z-index: 1020
    background-color: #000000
    color: #FFFFFF

    .nav
      display: flex
      flex-wrap: nowrap

    .back
      height: 24px
      float: left
      cursor: pointer

      .icon
        width: 36px
        height: 36px
        font-size: 2.25rem
        line-height: 1

    .title
      flex-grow: 1
      margin: 3px 0
      overflow: hidden
      font-size: 1.2081rem
      font-weight: bold
      text-align: center
      line-height: 28px
      white-space: nowrap
      text-overflow: ellipsis

    .placeholder
      width: 36px

  main
    padding: 58px 0 80px

    &.in-app
      padding: 0 0 80px

    .base-empty
      position: fixed
      top: calc(50% + 96px)
      left: 50%
      transform: translate(-50%, calc(-50% - 48px))
</style>
